<div class="container container-space">
  @if (profiel$ | async; as profiel) {
    @if (profiel.status === 'ACTIEF' || profiel.status === 'UITGENODIGD') {
      <parkour-profiel-details [profiel]="profiel">
        <p class="text-n-600" data-testid="rol" typeContent>
          {{ uitnodiging.rol | rolLabel }}
        </p>
        <parkour-card class="block mt-4" icon="check" topCardContent>
          <p class="font-medium">
            {{ 'team.uitnodiging.uitnodiging-teamlid-activeren-title' | translate }}
          </p>
          <p>{{ 'team.uitnodiging.uitnodiging-teamlid-activeren-description' | translate }}</p>

          <div class="flex items-center justify-between gap-4 mt-4">
            <parkour-button
              (clicked)="onVerwijderUitnodiging()"
              class="w-full"
              size="small"
              variant="tertiary"
            >
              {{ 'buttons.nee' | translate }}
            </parkour-button>
            <parkour-button
              (clicked)="onBevestigUitnodiging()"
              class="w-full"
              size="small"
              variant="secondary"
            >
              {{ 'buttons.ja' | translate }}
            </parkour-button>
          </div>
        </parkour-card>
        @if (profiel.verificatieStatus === 'GEVERIFIEERD') {
          <parkour-profiel-details-geverifieerd-card />
        }
      </parkour-profiel-details>
    }
  }
</div>
